(ns teamoesterreich.admin-mode.administration.organisation.organisation-form
  (:require
    [clojure.string :as string]
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.cancel :refer [cancel]]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent-material-ui.icons.save :refer [save]]
    [teamoesterreich.util.helper :as h]                     ;;(h/event-value e)
    [reagent.core :as r]
    [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
    [teamoesterreich.admin-mode.data.rights :as d-rights]
    [teamoesterreich.admin-mode.data.organisation :as d-organisation]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.admin-mode.static-data :as staticData]
    [teamoesterreich.syncer :as syncer]
    [teamoesterreich.util.log :as log]
    ))




;:organisation-key
;:organisation-name
;:organisation-type
;:organisation-okey
;:organisation-email
;:organisation-tafelEmail
;:organisation-userInfo
;:organisation-lrEmail

;(defn get-parent [key]
;  (reduce (fn [c [reg name]]
;            (if (re-find (re-pattern (str reg)) key) (str name) c)) "-" staticData/DEP_LIST))




(defn get-it [!selected !list-loaded?]
  (let [!st (r/atom {:form nil :loaded false :form-hash (rand-int 12)})
        !form-hash (r/cursor !st [:form-hash])
        !form (r/cursor !st [:form])
        !orig (r/cursor !st [:orig])
        !edit-mode (r/cursor !st [:edit-mode])
        !delete-popup (r/cursor !st [:delete-popup])
        !loaded (r/cursor !st [:loaded])
        change-fn (fn [e v]
                    (swap! !form assoc e v))
        changed? (fn [k]
                   (not= (get @!orig k) (get @!form k)))]
    (fn []
      [mui/paper
       (if-not @!loaded
         (do
           (d-organisation/<get-organisation-by-key @!selected
                                                    (fn [data]
                                                      (swap! !st assoc
                                                             :orig data
                                                             :form data
                                                             :loaded true
                                                             )))
           [:div {:style {:marginTop "10px"}} [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}] "  Dienststelle loading..."])

         [mui/card
          {:style {:margin "10px"}}
          (log/debug "rerender form " (clj->js @!form))
          [mui/card-header {:title "Dienststelle Details"}]
          [mui/card-content
           [:form
            [mui/grid
             {:container  true
              :direction  "row"
              :justify    "flex-start"
              :alignItems "flex-start"
              :spacing    3
              }
             [are-you-sure-modal/are-you-sure-modal !delete-popup
              "Bist du sicher, dass du diesen Eintrag löschen möchtest? " "Ja löschen"
              (fn [_]
                (d-organisation/>organisation-delete @!selected (fn [_]))
                (syncer/get-organisations)
                (reset! !loaded false)
                (reset! !list-loaded? false)
                (reset! !selected nil)
                )]
             [mui/grid
              {:container false :item true
               :xs        4
               :style     {:padding "5px"}
               }
              [mui/text-field {
                               :style        {:backgroundColor (if (changed? :organisation-key) "#ffd6d2" "#ffffff")}
                               :fullWidth    true
                               :disabled     (not @!edit-mode)
                               :defaultValue (str (:organisation-key @!form))
                               :onChange     (fn [e] (change-fn :organisation-key (h/event-value e)))
                               :label        "Nummer"}]
              ]
             [mui/grid
              {:container false :item true
               :xs        4
               :style     {:padding "5px"}
               }
              [mui/text-field {
                               :style        {:backgroundColor (if (changed? :organisation-orgFilter) "#ffd6d2" "#ffffff")}
                               :fullWidth    true
                               :disabled     (or (not @!edit-mode) (= (:organisation-level @!form) 3))
                               :defaultValue (str (if (= (:organisation-level @!form) 3) (:organisation-key @!form) (:organisation-orgFilter @!form)))
                               :onChange     (fn [e] (change-fn :organisation-orgFilter (h/event-value e)))
                               :label        "Filter (Substrukturen) RegEx z.B.: `1.*` mit 1 beginnt "}]
              ]
             [mui/grid
              {:container false :item true
               :xs        3
               :style     {:padding "5px"}
               }

              [mui/grid
               {:container false :item true
                :md        6
                :xs        12
                :style     {:padding "5px"}
                }
               [mui/form-label "Stufe"
                [mui/select
                 {:style        {:backgroundColor (if (changed? :organisation-level) "#ffd6d2" "#ffffff")}
                  :fullWidth    true
                  :disabled     (not @!edit-mode)
                  :defaultValue (str (:organisation-level @!form))
                  :onChange     (fn [e] (change-fn :organisation-level (h/event-value e)))
                  :label        "Stufe"}

                 [mui/menu-item {:value 1} (str "1 " (txt/txt :rights-level 1))]
                 [mui/menu-item {:value 2} (str "2 " (txt/txt :rights-level 2))]
                 [mui/menu-item {:value 3} (str "3 " (txt/txt :rights-level 3))]
                 ]]
               ]]

             [mui/grid
              {:container false :item true
               :md        1
               :xs        12
               :style     {:padding "5px"}
               } ""]

             [mui/grid
              {:container false :item true
               :md        6
               :xs        12
               :style     {:padding "5px"}
               }
              ^{:key (str "organisation-name" @!form-hash)} ;; does rerender on change
              [mui/text-field {
                               :style        {:backgroundColor (if (changed? :organisation-name) "#ffd6d2" "#ffffff")}
                               :fullWidth    true
                               :disabled     (not @!edit-mode)
                               :defaultValue (str (:organisation-name @!form))
                               :onChange     (fn [e] (change-fn :organisation-name (h/event-value e)))
                               :label        "Name"}]
              ]


             [mui/grid
              {:container false :item true
               :md        6
               :xs        12
               :style     {:padding "5px"}
               } ""]


             [mui/grid
              {:container false :item true
               :lg        4
               :md        6
               :xs        6
               :style     {:padding "5px"}
               }
              ^{:key (str "organisation-email" @!form-hash)} ;; does rerender on change
              [mui/text-field {
                               :style        {:backgroundColor (if (changed? :organisation-email) "#ffd6d2" "#ffffff")}
                               :fullWidth    true
                               :disabled     (not @!edit-mode)
                               :defaultValue (str (:organisation-email @!form))
                               :onChange     (fn [e] (change-fn :organisation-email (h/event-value e)))
                               :label        "Email"}]
              ]
             [mui/grid
              {:container false :item true
               :lg        4
               :md        6
               :xs        6
               :style     {:padding "5px"}
               }
              ^{:key (str "organisation-tafelEmail" @!form-hash)} ;; does rerender on change
              [mui/text-field {
                               :style        {:backgroundColor (if (changed? :organisation-tafelEmail) "#ffd6d2" "#ffffff")}
                               :fullWidth    true
                               :disabled     (not @!edit-mode)
                               :defaultValue (str (:organisation-tafelEmail @!form))
                               :onChange     (fn [e] (change-fn :organisation-tafelEmail (h/event-value e)))
                               :label        "Tafel Email"}]
              ]
             [mui/grid
              {:container false :item true
               :lg        4
               :md        6
               :xs        6
               :style     {:padding "5px"}
               }
              ^{:key (str "organisation-lrEmail" @!form-hash)} ;; does rerender on change
              [mui/text-field {
                               :style        {:backgroundColor (if (changed? :organisation-lrEmail) "#ffd6d2" "#ffffff")}
                               :fullWidth    true
                               :disabled     (not @!edit-mode)
                               :defaultValue (str (:organisation-lrEmail @!form))
                               :onChange     (fn [e] (change-fn :organisation-lrEmail (h/event-value e)))
                               :label        "Lebensretter Email"}]
              ]


             [mui/grid
              {:container false :item true
               :xs        6
               :style     {:padding "5px"}
               }
              ^{:key (str "organisation-zips" @!form-hash)} ;; does rerender on change
              [mui/text-field {
                               :style        {:backgroundColor (if (changed? :organisation-zip) "#ffd6d2" "#ffffff")}
                               :fullWidth    true
                               :disabled     (or (not (d-rights/is-superuser?)) (not @!edit-mode))
                               :defaultValue (str "" (string/join "," (sort (or (:organisation-zip @!form) []))))
                               :onChange     (fn [e]
                                               (let [val (h/event-value e)
                                                     zips (string/split val #",")
                                                     ]
                                                 (log/debug (clj->js zips))
                                                 (change-fn :organisation-zip zips)
                                                 ))
                               :label        "Postleitzahlen [1010,1020,]"}]
              ]

             [mui/grid
              {:container false :item true
               :md        12 :xs 12
               :style     {:marginTop "5px"}
               }
              (when @!edit-mode
                [mui/button {:startIcon (r/as-element [cancel]) :variant "outlined" :color "" :style {:margin "5px 40px 5px 0"}
                             :onClick   (fn []
                                          (reset! !form @!orig)
                                          (reset! !form-hash (rand-int 12))
                                          (reset! !edit-mode false))
                             }
                 "Abbrechen"])

              (when @!edit-mode
                [mui/button {:startIcon (r/as-element [save]) :variant "outlined" :color "primary" :style {:margin "5px 40px 5px 0"}
                             :disabled  (not (or
                                               (changed? :organisation-key)
                                               (changed? :organisation-name)
                                               (changed? :organisation-level)
                                               (changed? :organisation-orgFilter)
                                               (changed? :organisation-email)
                                               (changed? :organisation-lrEmail)
                                               (changed? :organisation-tafelEmail)
                                               (changed? :organisation-zip)
                                               ))
                             :onClick   (fn []
                                          (log/debug "FORM " @!form)
                                          (d-organisation/>organisation-edit
                                            @!selected
                                            {:organisation-key        (:organisation-key @!form)
                                             :organisation-name       (str (:organisation-name @!form))
                                             :organisation-level      (or (:organisation-level @!form) 3)
                                             :organisation-orgFilter  (str (if (= (or (:organisation-level @!form) 3) 3)
                                                                             (:organisation-key @!form)
                                                                             (:organisation-orgFilter @!form)))
                                             :organisation-email      (str (:organisation-email @!form))
                                             :organisation-lrEmail    (str (:organisation-lrEmail @!form))
                                             :organisation-tafelEmail (str (:organisation-tafelEmail @!form))
                                             :organisation-zip        (:organisation-zip @!form)
                                             }
                                            (fn [data]
                                              (swap! !st assoc
                                                     :orig data
                                                     :form data
                                                     :edit-mode false
                                                     )
                                              (syncer/get-organisations)
                                              (reset! !loaded false)
                                              (reset! !list-loaded? false)
                                              (when  (not= @!selected (:organisation-key @!form)
                                                           (reset! !selected (:organisation-key @!form)))
                                                )
                                              )))
                             }
                 "Speichern"])

              (when-not @!edit-mode
                [mui/button {:startIcon (r/as-element [keyboard-arrow-left]) :variant "outlined" :style {:margin "5px 40px 5px 0"}
                             :onClick   #(reset! !selected nil)
                             }
                 "Zurück"])

              (when (and (not @!edit-mode) (d-rights/allow-admin-for d-rights/ADMIN_ORG (:organisation-orgFilter @!form)))
                [mui/button {:startIcon (r/as-element [edit]) :variant "outlined" :color "secondary" :style {:margin "5px 40px 5px 0"}
                             :onClick   #(reset! !edit-mode true)
                             }
                 "Bearbeiten"])

              (when (and (not @!edit-mode) (d-rights/allow-admin-for d-rights/ADMIN_ORG (:organisation-orgFilter @!form)))
                [mui/button {:startIcon (r/as-element [delete-forever]) :variant "outlined" :color "primary" :style {:margin "5px 40px 5px 0"}
                             :onClick   #(reset! !delete-popup true)

                             }
                 "Löschen"])
              ]
             ]
            ]
           ]])])))






